import React from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { Box } from '@wds/box';
import { PackageProps, NavRouteParams, PackageType } from '~pricing/lib/summaryPackages';

import PackageCta from '~pricing/components/PackageCta';
import PackageHeader from '~pricing/components/PackageHeader';
import PackageDefs from './packageDefs';
import usePackageStyles from '~pricing/components/Summary/useStyles';
import FeatureSet from '~pricing/components/FeatureSet';
import useSummaryDisplayFeatures from '~pricing/hooks/useSummaryDisplayFeatures';
import SummaryFeatureTransformers from '~pricing/transformers/summary';

type PackagePropType = Omit<PackageProps, 'ribbonText'>;

export default function Package({
  ctaLabel,
  details,
  skuCost,
  package: packageName,
  features,
}: PackagePropType): React.ReactElement | null {
  const { canonicalPath = PackageType.Teams } = useParams<NavRouteParams>();
  const displayFeatures = useSummaryDisplayFeatures(features, SummaryFeatureTransformers[packageName]);
  const { PricingPackageContainer, PricingPackage, Highlighted, PlanFeaturesLink } = usePackageStyles({ packageName });

  if (!SummaryFeatureTransformers[packageName]) {
    return null;
  }

  return (
    <Box element="article" className={PricingPackageContainer} key={packageName} data-testid="Package">
      <Box className={`${PricingPackage} ${PackageDefs[packageName].highlighted ? Highlighted : ''}`}>
        <PackageHeader
          ctaLabel={ctaLabel}
          skuCosts={skuCost}
          details={details}
          packageName={packageName}
          packageType={canonicalPath}
        />
        <FeatureSet features={displayFeatures} packageName={packageName} />
        <Box className={PlanFeaturesLink}>
          <Link to={`/pricing/${canonicalPath}/details`}>See all plan features</Link>
        </Box>
      </Box>
      <PackageCta ctaLabel={ctaLabel} packageName={packageName} />
    </Box>
  );
}
